/* ── Shared Railway Decorative Patterns ── */
const watermarkImg = 'https://public.readdy.ai/ai/img_res/f10e5170-613f-4c80-9505-283d08035ad2.png';

/* ── Railway Tie Pattern (Sleepers) — card background decoration ── */
export function RailwayTiesPattern() {
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden z-0"
      style={{ opacity: 0.04 }}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'repeating-linear-gradient(90deg, transparent, transparent 28px, #B22222 28px, #B22222 30px, transparent 30px, transparent 60px)',
          backgroundSize: '60px 100%',
        }}
      />
      {/* Two faint rail lines across the top */}
      <div className="absolute top-2 left-0 right-0 h-[1px] bg-[#B22222]/6" />
      <div className="absolute top-5 left-0 right-0 h-[1px] bg-[#B22222]/6" />
    </div>
  );
}

/* ── Railway Crosshatch Pattern for Background ── */
export function RailwayCrosshatch() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-[0.07]">
      <div className="absolute inset-0" style={{ backgroundImage: 'repeating-linear-gradient(45deg, #B22222 0, #B22222 1px, transparent 1px, transparent 12px)' }} />
    </div>
  );
}

/* ── Railway Track Border Decoration ── */
export function RailwayTrackBorder() {
  return (
    <div className="absolute top-0 left-5 right-5 h-[3px] flex items-center pointer-events-none">
      <div className="h-[1px] flex-1 bg-[#B22222]/15" />
      <div className="flex items-center gap-[5px] mx-2">
        {[1,2,3,4,5,6,7].map(i => <div key={i} className="w-[2px] h-[3px] bg-[#B22222]/20 rounded-sm" />)}
      </div>
      <div className="h-[1px] flex-1 bg-[#B22222]/15" />
    </div>
  );
}

/* ── Railway Track Marks (for dark/red backgrounds) ── */
export function RailwayTrackMarks() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none select-none">
      <div className="absolute left-0 right-0 top-2 h-[1px] bg-white/25" />
      <div className="absolute left-0 right-0 top-5 h-[1px] bg-white/25" />
      <div className="absolute left-1 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-4 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-8 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-12 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-16 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-20 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-24 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-28 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-32 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute left-36 top-2 h-[3px] w-[1px] bg-white/20" />
      <div className="absolute -bottom-2 -right-2 w-28 h-28 rotate-12" style={{ opacity: 0.14 }}>
        <img src={watermarkImg} alt="" className="w-full h-full object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
      </div>
    </div>
  );
}

/* ── Railway Track Network — 交错轨道背景图（详情页） ── */
export function RailwayTrackNetwork() {
  const railColor = '#B22222';
  const opacity = 0.08;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0" style={{ opacity }}>
      <svg
        className="absolute w-full h-full"
        viewBox="0 0 1000 1000"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* ═══ 水平主轨道 ═══ */}
        <g>
          <line x1="0" y1="420" x2="1000" y2="420" stroke={railColor} strokeWidth="2.5" />
          <line x1="0" y1="426" x2="1000" y2="426" stroke={railColor} strokeWidth="2.5" />
          {/* 枕木 */}
          <line x1="0" y1="423" x2="1000" y2="423" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 斜向轨道 1 — 左上到右下 ═══ */}
        <g>
          <line x1="-80" y1="80" x2="1080" y2="920" stroke={railColor} strokeWidth="2.5" />
          <line x1="-80" y1="86" x2="1080" y2="926" stroke={railColor} strokeWidth="2.5" />
          <line x1="-80" y1="83" x2="1080" y2="923" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 斜向轨道 2 — 右上到左下 ═══ */}
        <g>
          <line x1="1080" y1="80" x2="-80" y2="920" stroke={railColor} strokeWidth="2.5" />
          <line x1="1080" y1="86" x2="-80" y2="926" stroke={railColor} strokeWidth="2.5" />
          <line x1="1080" y1="83" x2="-80" y2="923" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 垂直轨道 — 左侧 ═══ */}
        <g>
          <line x1="250" y1="0" x2="250" y2="1000" stroke={railColor} strokeWidth="2.5" />
          <line x1="256" y1="0" x2="256" y2="1000" stroke={railColor} strokeWidth="2.5" />
          <line x1="253" y1="0" x2="253" y2="1000" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 垂直轨道 — 右侧 ═══ */}
        <g>
          <line x1="750" y1="0" x2="750" y2="1000" stroke={railColor} strokeWidth="2.5" />
          <line x1="756" y1="0" x2="756" y2="1000" stroke={railColor} strokeWidth="2.5" />
          <line x1="753" y1="0" x2="753" y2="1000" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 曲线轨道 — 左上道岔 ═══ */}
        <g>
          <path d="M 0 300 Q 180 300 250 420" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 0 306 Q 180 306 250 426" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 0 303 Q 180 303 250 423" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" fill="none" />
        </g>

        {/* ═══ 曲线轨道 — 右上道岔 ═══ */}
        <g>
          <path d="M 1000 300 Q 820 300 750 420" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 1000 306 Q 820 306 750 426" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 1000 303 Q 820 303 750 423" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" fill="none" />
        </g>

        {/* ═══ 曲线轨道 — 右下道岔 ═══ */}
        <g>
          <path d="M 750 420 Q 820 540 1000 540" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 750 426 Q 820 546 1000 546" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 750 423 Q 820 543 1000 543" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" fill="none" />
        </g>

        {/* ═══ 曲线轨道 — 左下道岔 ═══ */}
        <g>
          <path d="M 250 420 Q 180 540 0 540" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 250 426 Q 180 546 0 546" stroke={railColor} strokeWidth="2.5" fill="none" />
          <path d="M 250 423 Q 180 543 0 543" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" fill="none" />
        </g>

        {/* ═══ 短支线 — 横向 ═══ */}
        <g>
          <line x1="350" y1="550" x2="650" y2="550" stroke={railColor} strokeWidth="2.5" />
          <line x1="350" y1="556" x2="650" y2="556" stroke={railColor} strokeWidth="2.5" />
          <line x1="350" y1="553" x2="650" y2="553" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 短支线 — 右上短斜线 ═══ */}
        <g>
          <line x1="600" y1="120" x2="900" y2="420" stroke={railColor} strokeWidth="2.5" />
          <line x1="606" y1="120" x2="906" y2="420" stroke={railColor} strokeWidth="2.5" />
          <line x1="603" y1="120" x2="903" y2="420" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 短支线 — 左下短斜线 ═══ */}
        <g>
          <line x1="100" y1="420" x2="400" y2="720" stroke={railColor} strokeWidth="2.5" />
          <line x1="106" y1="420" x2="406" y2="720" stroke={railColor} strokeWidth="2.5" />
          <line x1="103" y1="420" x2="403" y2="720" stroke={railColor} strokeWidth="12" strokeDasharray="2 38" />
        </g>

        {/* ═══ 交叉节点 — 圆圈标记 ═══ */}
        {/* 中心区域 */}
        <circle cx="500" cy="423" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="250" cy="423" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="750" cy="423" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        {/* 对角线交叉 */}
        <circle cx="500" cy="500" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        {/* 左侧 */}
        <circle cx="250" cy="250" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="250" cy="750" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        {/* 右侧 */}
        <circle cx="750" cy="250" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="750" cy="750" r="5" stroke={railColor} strokeWidth="1" fill="none" />
        {/* 曲线端点 */}
        <circle cx="250" cy="420" r="4" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="750" cy="420" r="4" stroke={railColor} strokeWidth="1" fill="none" />
        {/* 支线端点 */}
        <circle cx="500" cy="550" r="4" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="750" cy="250" r="4" stroke={railColor} strokeWidth="1" fill="none" />
        <circle cx="250" cy="570" r="4" stroke={railColor} strokeWidth="1" fill="none" />
      </svg>
    </div>
  );
}

/* ── Corner Railway Icon Watermark ── */
export function RailwayWatermark({ icon }: { icon: string }) {
  const isTrainIcon = icon === 'ri-train-line' || icon === 'ri-file-list-3-line' || icon === 'ri-award-line';
  if (isTrainIcon) {
    return (
      <div className="absolute -bottom-4 -right-4 w-24 h-24 pointer-events-none select-none rotate-12" style={{ opacity: 0.12 }}>
        <img src={watermarkImg} alt="" className="w-full h-full object-contain" />
      </div>
    );
  }
  return (
    <div className="absolute -bottom-4 -right-4 w-24 h-24 text-[#B22222]/12 pointer-events-none select-none rotate-12">
      <i className={`${icon} text-6xl`} />
    </div>
  );
}